import moment from 'moment'
import { Table, TableBody, TableHead, TableCell, TableContainer, TableRow, Paper, Typography } from '@mui/material'

const Summary = ({retailer, rows, bgColor}) => {
    
    return (

        <>
        <div style={{margin: '2rem auto'}} />
        <Typography variant='h5' style={{margin: '2rem auto'}} align='center' gutterBottom >{(retailer?.user?.name)}'s Products</Typography>
            <TableContainer elevation={3} sx={{ width: '80%', margin: 'auto' }} component={Paper}>
            <Table aria-label="simple table">
                { retailer && (
                    <>
                    <TableHead>
                    <TableRow sx={{ backgroundColor: `${bgColor}` }}>
                        <TableCell>Title</TableCell>
                        <TableCell align="right">Quantity&nbsp;</TableCell>
                        <TableCell align="right">Time stored&nbsp;</TableCell>
                        <TableCell align="right">Category&nbsp;</TableCell>
                    </TableRow>
                    </TableHead>
                    </>
                )}
                <TableBody>
                {rows.map((row) => (
                    <TableRow
                    key={row.addedDate}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    { (retailer?.user?.name === row.retailerName) && (
                        <>
                    <TableCell component="th" scope="row">
                        {row.title}
                    </TableCell>
                    <TableCell align="right">{row.quantity}</TableCell>
                    <TableCell align="right">{moment(row.addedDate).fromNow()}</TableCell>
                    <TableCell align="right">{row.category}</TableCell>
                        </>
                    ) }  
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
            <div style={{margin: '2rem auto'}} />
        </>
        );
    }
    export default Summary;